function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, React.createElement("style", null, ".cls-1,.primary{fill:none;}.white{fill:#fff;}.highlights{fill:#e8dbec;}.primary{stroke:#4f4954;stroke-linecap:round;stroke-linejoin:round;stroke-width:16px;}"));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "frame"
}, React.createElement("rect", {
  className: "cls-1",
  width: 256,
  height: 256,
  transform: "translate(256 256) rotate(-180)"
})), React.createElement("g", {
  id: "white"
}, React.createElement("path", {
  className: "white",
  d: "M163.26,145.35h-85l-42.4,18.42V36.35a9.24,9.24,0,0,1,9.25-9.22H163.26a9.24,9.24,0,0,1,9.25,9.22v99.78A9.24,9.24,0,0,1,163.26,145.35Z"
})), React.createElement("g", {
  id: "highlights"
}, React.createElement("path", {
  className: "highlights",
  d: "M232,122.36V232l-36.49-15.85H122.39a7.94,7.94,0,0,1-8-7.93V151.27H160.7a9.24,9.24,0,0,0,9.25-9.22V114.43H224A7.94,7.94,0,0,1,232,122.36Z"
})), React.createElement("g", {
  id: "primary"
}, React.createElement("path", {
  className: "primary",
  d: "M159.61,150.22h-85L32.22,168.64V41.22A9.24,9.24,0,0,1,41.47,32H159.61a9.24,9.24,0,0,1,9.25,9.22V141A9.24,9.24,0,0,1,159.61,150.22Z"
}), React.createElement("path", {
  className: "primary",
  d: "M64,119.62C64,104.2,72,75.2,120,83"
}), React.createElement("line", {
  className: "primary",
  x1: 136,
  y1: 83.26,
  x2: 115.8,
  y2: 63
}), React.createElement("line", {
  className: "primary",
  x1: 112.69,
  y1: 103,
  x2: 135.83,
  y2: 83.56
}), React.createElement("line", {
  className: "primary",
  x1: 136,
  y1: 83.26,
  x2: 115.8,
  y2: 63
}), React.createElement("line", {
  className: "primary",
  x1: 112.69,
  y1: 103,
  x2: 135.83,
  y2: 83.56
})));
var SvgRespond = function SvgRespond(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return React.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgRespond, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Respond.2722dd6e.svg";
export { ForwardRef as ReactComponent };